/* eslint-disable no-case-declarations */
import {
    CHANGE_LANG,
    SHOW_DEVELOP,
    SET_ALERT,
    SHOW_LOADING,
    SET_USER_MENUS,
    SET_FOOTER_MENUS,
    SET_ALL_PAGES,
} from '../actions/system';
import Cookies from 'js-cookie';

let lang = 'mn';
if (typeof window !== 'undefined') {
    const chosenLang = Cookies.get('chosen_lang');
    if (chosenLang) lang = chosenLang;
}

const initialState = {
    lang: lang,
    showDevelop: false,
    showLoading: false,
    alert: { isShow: false, type: 'success', message: '' },
    userMenus: [], // Header-ийн dynamic хуудсууд
    footerMenus: [], // Footer-ийн dynamic хуудсууд
    allPages: [], // Бүх pages (flat) — cover зураг, title-ыг URL-ээр хайхад
};

const systemReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_LANG:
            return { ...state, lang: action.data };
        case SHOW_DEVELOP:
            return { ...state, showDevelop: action.data };
        case SET_ALERT:
            return { ...state, alert: action.data };
        case SHOW_LOADING:
            return { ...state, showLoading: action.data };
        case SET_USER_MENUS:
            return { ...state, userMenus: action.data || [] };
        case SET_FOOTER_MENUS:
            return { ...state, footerMenus: action.data || [] };
        case SET_ALL_PAGES:
            return { ...state, allPages: action.data || [] };
        default:
            return state;
    }
};

export default systemReducer;
